<template>
    <div id="login">

        <div id="login_module" class="col-10 col-sm-4 col-md-4 col-lg-3">
            <img src="https://www.leffix.playworld.nl/themes/assets/playworld/logo_200.png" alt="">
            <h2>Reset Wachtwoord</h2>
            <div id="form">
                <form action="" @submit.prevent="send()">
                    <div class="form-group">
                        <input type="email" class="form-control" v-model="email" placeholder="Emailadres">
                    </div> 
                    <div class="form-group">
                        <p v-if="login_task.error" class="msg text-danger">{{login_task.error_msg}}</p>
                        <p v-if="login_task.success" class="msg text-success">{{login_task.success_msg}}</p>
                        <button :disabled="(login_task.task_loader ? true:false)" class="btn btn-party btn-theme btn-block p-2" type="submit">
                            <div id="task_loader" v-if="login_task.task_loader"></div>
                            {{'Reset'}}
                        </button>
                    </div>
                    <a class="mb-2" href="/login">Terug naar login</a> <br>
                    <br>
                </form>
            </div>
        </div>

    </div>
</template>

<script>
export default {
    name:'forgotpassword',
    data(){
        return {
            email:'',
            login_task:{
                sent:false,
                error:false,
                error_msg:'',
                success:false,
                success_msg:'',
                btntext:"INLOGGEN",
                task_loader:false
            }
        }
    },
    methods:{
        send(){
            this.login_task.error=false;

            if(this.email.trim().length==0){
                this.login_task.error=true;
                this.login_task.error_msg="Voer je emailadres in";

                return false;
                
            }

            this.login_task.task_loader=true;
            this.login_task.btntext="Aan het inloggen...";
            let email=this.email;
            this.$store.dispatch("post",{endpoint:this.$store.state.endpoint+'forgot-password',details:{email}})
            .then(data=>{
                window.console.log(data);
                this.login_task.task_loader=false;
                this.login_task.success=true;
                this.login_task.success_msg= "De verificatie link is naar je emailadres verzonden.";
                this.login_task.btntext="Verstuur";
                this.email="";
            })
            .catch(error=>{
                console.log('error', error.request);
                 
                // window.console.log(JSON.parse(error.request.response));
                this.login_task.error=true;
                this.login_task.error_msg="error in connectie, probeer opnieuw";

                this.login_task.task_loader=false;
                this.login_task.btntext="INLOGGEN";
            });
        }
    },
    created(){
        var user=JSON.parse(localStorage.getItem('user'));
        var token=JSON.parse(localStorage.getItem('token'));

        if(token != null && user !=null){
            window.location='/';
        }

    }
}
</script>

<style scoped>
    #task_loader{
        width: 20px;
        height: 20px;
        border: 2px solid gray;
        border-top: 2px solid white;
        border-radius: 50%;
        position: absolute;
        left: 15%;
        margin-top: 0.7%;
        animation: spin .6s linear infinite;
    }
     @keyframes spin{
        0%{
            transform: rotate(0deg);
        }
        100%{
            transform: rotate(360deg);
        }
    }
    body{
        background-color:#222 !important;
    }
    #login_module .foot{
        padding: 10px 16px;
    }
    #login_module .foot a{
        font-size: 13px;
        font-weight: bold;
        color: #545454;
    }
    #login_module{
        position: absolute;
        top:0;
        bottom:0;
        left:0;
        right:0;
        margin:auto;
        background: #222;
        display: table;
        border-radius: 5px;
        box-shadow: 0px 0px 3px gray;
    }
    #login_module img{
        width: 265px;
        display: block;
        margin: 0 auto;
        margin-top: -13px;
        background-color: #222;
        border-radius: 7px;
        box-shadow: 0px 0px 2px grey;
        padding: 5px 7px;
    }
    #login_module h2{
        text-align: center;
        margin: 20px 0px;
        color: #faba05;
        font-weight: 700;
    }
    #login_module form{
        text-align: center;
        
    }
    #login_module form input:focus{
        border:1px solid #faba05;
        box-shadow: none;
    }
</style>
